// Generated by BUCKLESCRIPT VERSION 2.2.2, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

function bullet(player) {
  var match = player[/* color */1];
  if (match !== 0) {
    return "•";
  } else {
    return "○";
  }
}

var component = ReasonReact.statelessComponent("Player");

function make(player, current, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: "player" + (
                    current !== 0 ? " current" : ""
                  )
                }, player[/* name */0], " " + bullet(player));
    });
  return newrecord;
}

exports.bullet = bullet;
exports.component = component;
exports.make = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/player.re
// module id = 45
// module chunks = 0